module.exports = __webpack_public_path__ + "static/media/Appointment_light.c6cfceec.png";